import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";



// components
import {GenericTableButton} from "../../../components/buttons/buttonsActions";

// labels
import {TT_CLOSE, TT_DELETE} from "../../../components/i18n/toolTips";
import {LB_ACTIONS, LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {glossaryService} from "../../../jwt/_services/xooka/glossaryService";

// utils
import {getStateByPath} from "../../../redux/selectors";
import {GenericButton} from "../../../components/buttons/customButtons";




const GlossaryList = (props) => {
    const {path, data:project} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading, listDomainObjects:glossaries} = componentState?.data || {};


   useEffect(() => {
        genericIndexedActions.search(path, glossaryService, 0, 0, {id:project?.id})
    }, []);

  const confirmDelete = data => genericIndexedActions.delete(path, glossaryService, data?.id, project?.id)


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '90px'},
            formatter: (cell, row) => <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
        }];


    const closeForm = () => props.onClose()


    return <Card  className={'card-modal'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}

            <div className={'top-right'}>
                <GenericButton
                    style={'danger-secondary'}
                    toolTip={TT_CLOSE}
                    icon={'fa-times'}
                    permission={'search'}
                    onClick={closeForm}
                />
            </div>
        </CardTitle>

        <CardBody>
            {
                loading
                    ? <div className="text-center">Cargando...</div>
                    : <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        loading={loading}
                        data={glossaries || []}
                        columns={ columns }
                        noDataIndication={NO_DATA_FOUND}
                    />
            }
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({})

export default connect(mapStateToProps, mapActionsToProps)(GlossaryList);